import React from "react";

export default function ProgressBar(props) {
  const {
    width,
    percentageText,
    fulldetails,
    subDetails,
  } = props;

  return (
    <div className="progress-container">
      {(subDetails || fulldetails) && percentageText && (
        <p className="progress-container__details m-0 font-16 font-bold">
          <span className="progress-container__summary">
            <span>{percentageText}</span>
            {fulldetails}
          </span>
          {subDetails ? (
            <span className="sub-details">{subDetails}</span>
          ) : null}
        </p>
      )}
      <div
        style={{ width: width ? width : "100%" }}
        className="progress"
      >
        <div
          className={`progress-bar ${
            percentageText === "100%" ? "done" : "inprogress"
          }`}
          role="progressbar"
          style={{ width: `${percentageText}` }}
          aria-valuenow={100}
          aria-valuemin={0}
          aria-valuemax={100}
        />
      </div>
      {percentageText && !fulldetails ? (
        <p className="m-0 ms-2 font-14 font-bold font-color-grey">
          <span>{percentageText}</span>
        </p>
      ) : null}
    </div>
  );
}
